const THEME = {
    skycell_primary_color: '#009CCF',
    skycell_dark: '#00739a',
    gray: '#b7b7b7',
}

export default THEME
